import { render } from "./Personas.vue?vue&type=template&id=6f89b92e"
import script from "./Personas.vue?vue&type=script&lang=js"
export * from "./Personas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/Personas.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f89b92e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f89b92e', __exports__)) {
    api.reload('6f89b92e', __exports__)
  }
  
  module.hot.accept("./Personas.vue?vue&type=template&id=6f89b92e", () => {
    api.rerender('6f89b92e', render)
  })

}


export default __exports__